<div class="aria-field" [class.aria-field--floating-label]="useFloatingLabel()">
  @if (label() && !useFloatingLabel()) {
    <label class="aria-field__label" [attr.for]="fieldId">
      {{ label() }}
      @if (required()) {
        <span class="aria-field__required" aria-hidden="true">*</span>
      }
    </label>
  }

  <div class="aria-field__control-row">
    @if (hasPrefix()) {
      <div class="aria-field__prefix">
        <ng-content select="[ariaFieldPrefix], app-quote-tooltip-help, [quoteFieldHelp]" />
      </div>
    }

    <div class="aria-field__control-area">
      <div
        class="aria-field__input-shell"
        [class.aria-field__input-shell--floating]="useFloatingLabel()"
        [class.aria-field__input-shell--filled]="isFilled()"
        [class.aria-field__input-shell--invalid]="!!errorMessage()"
      >
        <div
          class="aria-date-picker"
          ngCombobox
          #comboboxRef="ngCombobox"
          [readonly]="true"
          [disabled]="isDisabled()"
        >
          <input
            class="aria-field__control aria-field__control--readonly-select aria-field__control--with-suffix"
            ngComboboxInput
            type="text"
            [id]="fieldId"
            [name]="name()"
            [placeholder]="inputPlaceholder()"
            [required]="required()"
            [disabled]="isDisabled()"
            [attr.aria-invalid]="errorMessage() ? 'true' : null"
            [attr.aria-describedby]="describedBy()"
            readonly
            [(value)]="displayValue"
            (keydown)="onTriggerKeydown($event)"
          />

          <ng-template ngComboboxPopupContainer>
            @if (useMobileDrawer()) {
              <dialog ngComboboxDialog class="aria-date-picker__drawer">
                <app-aria-date-picker-panel
                  [selection]="selection()"
                  [minDate]="minDay()"
                  [maxDate]="maxDay()"
                  [viewMonth]="viewMonth()"
                  [doubleCalendar]="doubleCalendar()"
                  [enableYearMonthNavigation]="enableYearMonthNavigation()"
                  [granularity]="granularity()"
                  [enableRangePreview]="enableRangePreview()"
                  (daySelected)="onDaySelected($event)"
                  (monthChange)="onViewMonthChange($event)"
                />
              </dialog>
            } @else {
              <div
                #popupPanel
                ariaComboboxDialogPanel
                aria-labelledby="aria-panel-title"
                class="aria-date-picker__popup"
                [class.aria-date-picker__popup--above]="popupPlacement() === 'above'"
                [class.aria-date-picker__popup--below]="popupPlacement() === 'below'"
              >
                <app-aria-date-picker-panel
                  [selection]="selection()"
                  [minDate]="minDay()"
                  [maxDate]="maxDay()"
                  [viewMonth]="viewMonth()"
                  [doubleCalendar]="doubleCalendar()"
                  [enableYearMonthNavigation]="enableYearMonthNavigation()"
                  [granularity]="granularity()"
                  [enableRangePreview]="enableRangePreview()"
                  (daySelected)="onDaySelected($event)"
                  (monthChange)="onViewMonthChange($event)"
                />
              </div>
            }
          </ng-template>
        </div>

        @if (label() && useFloatingLabel()) {
          <label class="aria-field__floating-label" [attr.for]="fieldId">
            {{ label() }}
            @if (required()) {
              <span class="aria-field__required" aria-hidden="true">*</span>
            }
          </label>
        }

        <span class="aria-field__suffix-icon" aria-hidden="true">
          <app-icon
            name="CalendarBlank"
            [size]="24"
            [color]="suffixIconColor()"
            aria-hidden="true"
          />
        </span>
      </div>
    </div>
  </div>

  @if (hint()) {
    <p class="aria-field__hint" [id]="hintId">{{ hint() }}</p>
  }

  @if (errorMessage()) {
    <p class="aria-field__error" [id]="errorId" role="alert">{{ errorMessage() }}</p>
  }
</div>
